









































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import moment from 'moment';
import IInbound from '@/store/models/IInbound';
import IInboundDeliveryNotes from '@/store/models/IInboundDeliveryNotes';

@Component({
    components: {
        Snackbar
    }
})
export default class InboundsNoticeOfLossSelector extends Vue {
    @Prop({ type: Array, required: true })
    InboundList !: IInbound[];
    @Prop({ type: Array, required: true })
    InboundDeliveryNotesList !: IInboundDeliveryNotes[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
  
    inboundSelected: string = "";
    inboundDeliveryNotesSelected : IInboundDeliveryNotes[] = [];
    searchInboundDeliveryNotes: string = "";
    sortBy: string = 'code';
    sortDesc: boolean = false;
    headersInboundsDeliveryNotes: any = [
        { text: 'Company destination',
            align: 'start',
            value: 'companyDestinationName'
        },
        { text: 'Warehouse', value: 'warehouseName' },
        { text: 'Customer', value: 'customerName' },
        { text: 'Delivery Note Code', value: 'code' },
        { text: 'Inb. Dossier Number Source', value: 'codeSource' },
        { text: 'Inb. Dossier Number Destination', value: 'codeDestination' },
        { text: 'Date In', value: 'dateIn' }
    ];

    get WarehouseName() {
        if (this.inboundDeliveryNotesSelected.length > 0) {
            return this.inboundDeliveryNotesSelected[0].warehouseName;
        }
        return "";
    }

    @Watch('inboundSelected')
    onChangeInbound() {
        const matches: IInbound[] = this.InboundList.filter(i =>
            i.code === this.inboundSelected || i.codeDestination === this.inboundSelected
        );

        // Si quieres ver cuántos hay:
        const countSameCode = matches.length;

        // Emitir array de inbounds
        this.$emit('onChangeInbound', matches);

    // (Opcional) si también quieres emitir el contador:
    // this.$emit('onChangeInbound', { inbounds: matches, countSameCode });
    }

    @Watch('inboundDeliveryNotesSelected')
    onChangeSelectedInboundDeliveryNotes() {
        this.$emit('onChangeSelectedInboundDeliveryNotes', this.inboundDeliveryNotesSelected);
    }

    get inboundItems() : string[] {
        let inboundsCode: string[] = this.InboundList.map(t => t.code);
        let inboundsCodeDestination: string[] = this.InboundList.map(t => t.codeDestination);
        return inboundsCode.concat(inboundsCodeDestination);
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    select(item : IInboundDeliveryNotes) : void {
        let index : number = this.inboundDeliveryNotesSelected.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.inboundDeliveryNotesSelected = [item];
        } else {
            let inboundDeliveryNotes = this.inboundDeliveryNotesSelected.find(w => w.id === item.id);
            if (!inboundDeliveryNotes) {
                this.inboundDeliveryNotesSelected = [];
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
